import { useEffect, useState, useRef } from 'react';

export function useHideOnScroll(ref) {
  const [hidden, setHidden] = useState(false);
  const lastY = useRef(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const onScroll = () => {
      const y = el.scrollTop;
      const maxY = el.scrollHeight - el.clientHeight;

      const scrollingDown = y > lastY.current;

      // Если в самом низу — НЕ показываем хедер
      if (y >= maxY - 5) {
        setHidden(true);
      }
      // Скроллим вниз
      else if (scrollingDown && y > 50) {
        setHidden(true);
      }
      // Скроллим вверх
      else if (!scrollingDown) {
        setHidden(false);
      }

      lastY.current = y;
    };

    el.addEventListener('scroll', onScroll, { passive: true });
    return () => el.removeEventListener('scroll', onScroll);
  }, [ref]);

  return hidden;
}

